import * as actionTypes from '../types/adminMailing';

export function getMailing(payload) {
  return {
    type: actionTypes.GET_MAILING,
    payload
  };
}

export function getMailingSuccess(payload) {
  return {
    type: actionTypes.GET_MAILING_SUCCESS,
    payload
  };
}

export function getMailingFail(payload) {
  return {
    type: actionTypes.GET_MAILING_FAIL,
    payload
  };
}

export function addMailing(payload) {
  return {
    type: actionTypes.ADD_MAILING,
    payload
  };
}

export function addMailingSuccess(payload) {
  return {
    type: actionTypes.ADD_MAILING_SUCCESS,
    payload
  };
}

export function addMailingFail(payload) {
  return {
    type: actionTypes.ADD_MAILING_FAIL,
    payload
  };
}

export function addMailingClear(payload) {
  return {
    type: actionTypes.ADD_MAILING_CLEAR,
    payload
  };
}
